import { useEffect, useState } from "react";
import Bubble from "./Bubble";

export default function ThemeToggle() {

  const [dark, setDark] = useState(() => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    document.body.classList.toggle('dark', dark);
  }, [dark]);

  return (
    <div
     style={{
        position: 'fixed',
        left: '1rem',
        bottom: '1rem',
        zIndex: 1000,
     }}
    >
      <Bubble poppable={false} size="3.5rem" className="m-0">
        <button 
          className='btn'
          onClick={() => setDark(!dark)}
          style={{ width: '100%', height: '100%' }}
          aria-label="Toggle Dark Mode"
        >
          {dark ? 
            <i className="bi bi-sun-fill"></i> 
            : 
            <i className="bi bi-moon-fill"></i>
          }
        </button>
      </Bubble>
    </div>
  );
}